import { render } from "./add_product_component.vue?vue&type=template&id=4dcccfb4&scoped=true"
import script from "./add_product_component.vue?vue&type=script&lang=js"
export * from "./add_product_component.vue?vue&type=script&lang=js"

import "./add_product_component.vue?vue&type=style&index=0&id=4dcccfb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dcccfb4"]])

export default __exports__